import axios from "axios";
import { toast } from "react-toastify";

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL, // ví dụ: http://localhost:4000
  timeout: 60000,
  withCredentials: true,
});

// cảnh báo thiếu baseURL
if (!api.defaults.baseURL && process.env.NODE_ENV !== "production") {
  // eslint-disable-next-line no-console
  console.warn("[axios] Missing REACT_APP_BACKEND_URL");
}

// chống spam toast trong 1 khoảng ngắn
let lastToastAt = 0;

const toastOnce = (msg, type = "error", gapMs = 1000) => {
  const now = Date.now();
  if (now - lastToastAt > gapMs) {
    toast(msg, { type, autoClose: 1500 });
    lastToastAt = now;
  }
};

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // nếu request bị huỷ thì bỏ qua
    if (axios.isCancel?.(error) || error?.code === "ERR_CANCELED") {
      return Promise.reject(error);
    }

    const status = error?.response?.status;
    const dataMsg = error?.response?.data?.message;
    let message = "";

    if (status === 429) {
      message = dataMsg || "Bạn đã vượt quá số lần yêu cầu, vui lòng thử lại sau!";
    } else if (status === 401) {
      // gợi ý: refresh token / điều hướng đăng nhập
      message = dataMsg || "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.";
      // ví dụ: redirectLogin(); // tuỳ app của bạn
    } else if (error?.code === "ECONNABORTED") {
      message = "Hết thời gian chờ. Vui lòng thử lại.";
    } else if (error?.message === "Network Error" || !navigator.onLine) {
      message = "Không có kết nối mạng. Kiểm tra Internet rồi thử lại.";
    } else {
      message = dataMsg || "Đã có lỗi xảy ra. Vui lòng thử lại.";
    }

    if (message) {
      toastOnce(message, "error");
      console.error("[API]", status || error?.code || "ERR", message);
    }

    return Promise.reject(error);
  }
);

export default api;
